import type { InferRpcDefinition } from "@redotech/rpc/definition";
import {
  createCsatSurveyTemplate,
  getCsatResponsesForTeam,
  getCsatResponsesForTeamCount,
  getCsatSurveyTemplates,
  getCsatVariantStats,
} from "./schema/csat";
import { getCallRecordWithTranscript } from "./schema/get-call-record-with-transcript";
import { getConversationInsights } from "./schema/get-conversation-insights";
import { getConversationInsightsCount } from "./schema/get-conversation-insights-count";
import { getSupportAiPricing } from "./schema/get-support-ai-pricing";
import { grantFreeTrialCredits } from "./schema/grant-free-trial-credits";
import { getPhoneNumberForTeam } from "./schema/phone-number";
import { searchTelnyxPhoneNumbers } from "./schema/search-telnyx-phone-numbers";
import { setupPhoneNumber } from "./schema/setup-phone-number";
import { getTelnyxTelephonyToken } from "./schema/telnyx-telephony-token";
import { toggleCallBeingRecorded } from "./schema/toggle-call-being-recorded";
import { toggleCallOnHold } from "./schema/toggle-call-on-hold";
import { turnOnSupportDefaults } from "./schema/turn-on-support-defaults";
import { updateSupportSettings } from "./schema/update-support-settings";

export const supportMerchantRpcDefinition = {
  getCallRecordWithTranscript,
  createCsatSurveyTemplate,
  getCsatResponsesForTeam,
  getCsatResponsesForTeamCount,
  getCsatSurveyTemplates,
  getCsatVariantStats,
  getPhoneNumberForTeam,
  getSupportAiPricing,
  getTelnyxTelephonyToken,
  searchTelnyxPhoneNumbers,
  setupPhoneNumber,
  toggleCallBeingRecorded,
  toggleCallOnHold,
  turnOnSupportDefaults,
  updateSupportSettings,
  getConversationInsights,
  getConversationInsightsCount,
  grantFreeTrialCredits,
} as const;

export type SupportMerchantRpcDefinition = InferRpcDefinition<
  typeof supportMerchantRpcDefinition
>;
